import { Icon } from '@smg-real-estate/domus';

import { BackFillAccountIds } from '@/components/ListingDetails/types';

export interface ListingStats {
  viewedNumber: number;
  addedFavouriteNumber: number;
  contactedEmailNumber: number;
  contactedPhoneNumber: number;
  onlineDays: number;
  listingId: string;
}

export interface ListingStatItem {
  title: string;
  value: number | string;
  icon: Icon;
}

export interface ListingStatBlurryItem {
  title: string;
  icon: Icon;
}

export const ppaListerPrefixes = ['hgo', 'is24', 'hgar'];
export const listingStatsListerPrefixes = [
  ...ppaListerPrefixes,
  BackFillAccountIds.TUTTI,
  BackFillAccountIds.ANIBIS,
  BackFillAccountIds.WEEGEE,
  BackFillAccountIds.WEEGEE_TEST,
];
